import { render, staticRenderFns } from "./TeamList.vue?vue&type=template&id=e195fce0&scoped=true"
import script from "./TeamList.vue?vue&type=script&lang=js"
export * from "./TeamList.vue?vue&type=script&lang=js"
import style0 from "./TeamList.vue?vue&type=style&index=0&id=e195fce0&prod&lang=scss&scoped=true"
import style1 from "./TeamList.vue?vue&type=style&index=1&id=e195fce0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e195fce0",
  null
  
)

export default component.exports